import React, {useEffect, useState} from "../_snowpack/pkg/react.js";
import styled from "../_snowpack/pkg/@emotion/styled.js";
import {getUrl} from "../common/universal.js";
import {
  formatLocalDate,
  getEditorUrl,
  getFormattedroductName,
  getPageEditor,
  getPageProduct,
  getTranslatedSlug,
  goTo,
  isStepsBasedConfig,
  mapSurface,
  withAttrs
} from "../common/utils.js";
import {Routes} from "../typings/routes.js";
import ProductConfiguration from "./product-configuration.js";
import ProductVariants from "./product-variants.js";
import ProductVariant from "./product-variant.js";
import {t} from "../common/i18n.js";
import ProductQuantitySlider from "./product-quantity-slider.js";
import ProductPriceOverview from "./product-price-overview.js";
import PrintTemplateDownloadButton from "./print-template-download-button.js";
import request from "../common/request.js";
import {colors, fontFamily, lineHeight, media} from "./theme.js";
import {ArrowLeft, Info} from "./icons.js";
import Button from "./button.js";
import Modal, {
  ConfirmModalButton,
  ConfirmModalFooter,
  ConfirmModalInner,
  showModalOnce
} from "./modal.js";
import ProductOptions from "./product-options.js";
import Collapse from "./collapse.js";
import Stack from "./stack.js";
import ProductOption from "./product-option.js";
import {useProductStore} from "../stores/product.js";
import {Title} from "./typo.js";
import {alert} from "./confirm.js";
import {Errors} from "../typings/errors.js";
import {captureException} from "../_snowpack/pkg/@sentry/react.js";
export default function ProductSidebar(props) {
  const {editor, ...rest} = props;
  const [store, setStore] = useProductStore();
  const {
    product,
    quantity,
    article,
    min,
    max,
    step,
    config,
    editorConfig,
    options,
    outsidePrintTemplateFile,
    insidePrintTemplateFile,
    cartItem,
    priceResponse
  } = store;
  const {articles, category, page, categoryItems} = product;
  const showCategoryBack = category && categoryItems && categoryItems > 1;
  const showBackSection = showCategoryBack || editor;
  const stepsBasedConfig = isStepsBasedConfig(product);
  const categoryUrl = category ? getUrl(Routes.productCategory, {slug: getTranslatedSlug(category)}) : void 0;
  const productUrl = getUrl(Routes.product, {
    slug: page.slug
  }, {
    query: {
      item_id: cartItem?.id,
      product_config: config,
      article_id: article?.id,
      quantity,
      option_ids: options?.map(({id}) => id)
    }
  });
  const printRequirements = editorConfig?.printRequirements ?? [];
  const printTemplateNeeded = printRequirements.length > 0;
  const showQuantitySlider = isSliderNeeded(article);
  const {value: prices, error: priceError} = priceResponse;
  const orderDisabled = !!priceError;
  const orderLoading = !prices;
  useEffect(() => {
    if (priceError && priceError.status === 418) {
      alert({
        title: t("Ups ein Fehler ist aufgetreten"),
        message: t("Für die Produktkonfiguration konnte leider kein Preis berechnet werden. Bitte wende dich an service@printmate.de")
      });
    }
  }, [priceError]);
  const onSliderChange = (n) => {
    setStore((s) => ({
      ...s,
      quantity: n
    }));
  };
  const onVariantChange = (id) => {
    const variant = articles.find((v) => v.id === id);
    if (!variant)
      return;
    setStore((prev) => ({
      ...prev,
      article: variant
    }));
  };
  const onConfigChange = (c) => {
    setStore((s) => ({...s, config: c}));
  };
  const onOptionsChange = (ids) => {
    if (!product.options)
      return;
    const options2 = product.options.filter((o) => ids.includes(o.id));
    setStore((s) => ({...s, options: options2}));
  };
  const pageProduct = getPageProduct(page);
  const isVariableProd = pageProduct.component === "variable_product";
  return /* @__PURE__ */ React.createElement(SidebarContainer, {
    ...rest
  }, showBackSection && /* @__PURE__ */ React.createElement(BackLinkSection, {
    editor
  }, editor ? /* @__PURE__ */ React.createElement(BackLink, {
    href: productUrl
  }, /* @__PURE__ */ React.createElement(LinkIcon, null), " ", t("zurück zum Produkt")) : showCategoryBack && /* @__PURE__ */ React.createElement(BackLink, {
    href: categoryUrl
  }, /* @__PURE__ */ React.createElement(LinkIcon, null), " ", t("zurück zur Produktauswahl"))), editor && /* @__PURE__ */ React.createElement(ProductTitle, {
    level: 5
  }, getFormattedroductName(product)), isVariableProd && article.plannedDeliveryDate && /* @__PURE__ */ React.createElement(SidebarSection, null, /* @__PURE__ */ React.createElement(SectionHeadline, null, "📦 ", t("Liefertermin ")), /* @__PURE__ */ React.createElement(SectionValue, null, formatLocalDate(article.plannedDeliveryDate))), /* @__PURE__ */ React.createElement(ProductConfiguration, {
    readOnly: editor || stepsBasedConfig,
    page,
    article,
    values: config,
    onChange: onConfigChange,
    error: priceError
  }), /* @__PURE__ */ React.createElement(VariantSection, {
    articles,
    selectedVariant: article,
    onVariantChange,
    editor
  }), /* @__PURE__ */ React.createElement(OptionsSection, {
    options: product.options,
    selectedOptions: options,
    optionsPrices: prices?.optionsPrices,
    quantity,
    editor,
    onOptionsChange
  }), /* @__PURE__ */ React.createElement(SidebarSection, null, /* @__PURE__ */ React.createElement(SectionHeadline, null, t("Auflage")), showQuantitySlider ? /* @__PURE__ */ React.createElement(ProductQuantitySlider, {
    value: quantity,
    min,
    max,
    step,
    onChange: onSliderChange
  }) : /* @__PURE__ */ React.createElement(SectionValue, null, quantity, " ", t("Stk"))), /* @__PURE__ */ React.createElement(SidebarSection, null, /* @__PURE__ */ React.createElement(ProductPriceOverview, {
    ...prices
  })), /* @__PURE__ */ React.createElement(SidebarSection, null, /* @__PURE__ */ React.createElement(NextButton, {
    quantity,
    page,
    article,
    articleOptions: options,
    articleConfig: config,
    cartItem,
    outsidePrintTemplateFile,
    insidePrintTemplateFile,
    editor,
    printRequirements,
    disabled: orderDisabled,
    loading: orderLoading
  }), printTemplateNeeded && /* @__PURE__ */ React.createElement(PrintTemplateDownloadButton, {
    article,
    product,
    config,
    disabled: orderDisabled
  })));
}
function isSliderNeeded(article) {
  return article.cf_quantity_maximum !== article.cf_quantity_minimum;
}
function VariantSection(props) {
  const {articles, selectedVariant, editor, onVariantChange} = props;
  if (!articles.filter((a) => a.variant).length)
    return null;
  if (editor) {
    const {variant} = selectedVariant;
    if (!variant)
      return null;
    return /* @__PURE__ */ React.createElement(SidebarSection, null, /* @__PURE__ */ React.createElement(ProductVariant, {
      article: selectedVariant,
      variant
    }));
  }
  return /* @__PURE__ */ React.createElement(SidebarSection, null, /* @__PURE__ */ React.createElement(ProductVariants, {
    articles,
    selectedVariantId: selectedVariant.id,
    onChange: onVariantChange
  }));
}
function OptionsSection(props) {
  const {
    options,
    selectedOptions,
    optionsPrices = {},
    quantity,
    editor,
    onOptionsChange
  } = props;
  if (!options)
    return null;
  if (!options.length)
    return null;
  if (editor && !selectedOptions.length)
    return null;
  if (editor) {
    return /* @__PURE__ */ React.createElement(SidebarSection, null, /* @__PURE__ */ React.createElement(SectionHeadline, null, t("Zusätzliche Optionen")), selectedOptions.map((o) => /* @__PURE__ */ React.createElement(ProductOption, {
      key: o.id,
      article: o,
      quantity,
      option: o.option,
      prices: optionsPrices[o.id],
      readOnly: !!editor
    })));
  }
  return /* @__PURE__ */ React.createElement(SidebarSection, null, /* @__PURE__ */ React.createElement(Collapse, {
    header: /* @__PURE__ */ React.createElement(SectionHeadline, null, t("Zusätzliche Optionen"))
  }, /* @__PURE__ */ React.createElement(ProductOptions, {
    articles: options,
    selectedOptionIds: selectedOptions.map(({id}) => id),
    quantity,
    onChange: onOptionsChange,
    optionsPrices
  })));
}
function NextButton(props) {
  const {
    editor,
    page,
    quantity,
    article,
    articleOptions,
    cartItem,
    articleConfig,
    outsidePrintTemplateFile,
    insidePrintTemplateFile,
    printRequirements,
    disabled,
    loading: initialLoading
  } = props;
  const [loading, setLoading] = useState(initialLoading);
  const options = {
    quantity,
    slug: page.slug,
    article_id: article.id,
    option_ids: articleOptions.map(({id}) => id).join(","),
    item_id: cartItem?.id,
    product_config: articleConfig,
    outside_print_template_name: outsidePrintTemplateFile?.name,
    outside_print_template_path: outsidePrintTemplateFile?.path,
    inside_print_template_name: insidePrintTemplateFile?.name,
    inside_print_template_path: insidePrintTemplateFile?.path
  };
  const editorContent = getPageEditor(page);
  const productDoesntHaveEditor = !editorContent;
  useEffect(() => {
    setLoading(initialLoading);
  }, [initialLoading]);
  if (editor || productDoesntHaveEditor) {
    const onOrderClick = async () => {
      if (shouldShowModal(printRequirements, insidePrintTemplateFile, outsidePrintTemplateFile)) {
        return showModalOnce(page.slug, (hide) => /* @__PURE__ */ React.createElement(ConfirmModalFixed, {
          icon: /* @__PURE__ */ React.createElement(Info, null),
          title: t("Design hochladen nicht vergessen"),
          active: true
        }, /* @__PURE__ */ React.createElement(ConfirmModalInner, null, t("Bevor du den Artikel in den Warenkorb legst, lade erst deine Druckvorlage hoch."), /* @__PURE__ */ React.createElement(ConfirmModalFooter, null, /* @__PURE__ */ React.createElement(ConfirmModalButton, {
          onClick: hide
        }, t("OK"))))));
      }
      try {
        setLoading(true);
        if (cartItem) {
          const editUrl = getUrl(Routes.cartUpdateItem, {
            item_id: cartItem.id
          });
          await request(editUrl, {method: "put", body: options});
        } else {
          const orderUrl = getUrl(Routes.cartAddItem);
          await request(orderUrl, {method: "post", body: options});
        }
        goTo(Routes.cartRenderCustomerCart);
      } catch (e) {
        captureException(e);
        if (e.type === Errors.MaxAmountOfArticleInCart) {
          return alert({
            message: t("Du kannst kein weiteres Produkt dieser Art in den Warenkorb legen"),
            title: t("Maximale Anzahl eines Produkt erreicht")
          });
        }
        return alert({
          message: t("Bitte den Support kontaktieren unter service@printmate.de")
        });
      } finally {
        setLoading(initialLoading);
      }
    };
    return /* @__PURE__ */ React.createElement(NextButtonContainer, {
      onClick: onOrderClick,
      disabled,
      loading
    }, cartItem ? t("Änderungen speichern") : t("Produkt bestellen"));
  }
  const editorUrl = getEditorUrl(page, options);
  const editing = !!cartItem;
  const noTemplateNeeded = printRequirements.length === 0;
  if (noTemplateNeeded) {
    return /* @__PURE__ */ React.createElement(NextButtonContainer, {
      href: editorUrl,
      disabled,
      loading
    }, t("Produkt ansehen"));
  }
  return /* @__PURE__ */ React.createElement(NextButtonContainer, {
    href: editorUrl,
    disabled,
    loading
  }, editing ? t("Druckbild anpassen") : t("Produkt gestalten"));
}
function shouldShowModal(printRequirements, insidePrintTemplateFile, outsidePrintTemplateFile) {
  const missing = printRequirements.map((p) => mapSurface(p) === "inside" ? !insidePrintTemplateFile : !outsidePrintTemplateFile);
  return missing.some((r) => r);
}
const SidebarContainer = styled.div``;
const BackLink = styled.a`
  display: inline-flex;
  align-items: center;
  font-family: ${fontFamily.secondary};
  font-weight: 700;
  font-size: 14px;
  height: 24px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: ${colors.b};
  text-decoration: none;
`;
const LinkIcon = styled(ArrowLeft)`
  margin-right: 8px;
`;
const SectionHeadline = styled.div`
  font-family: ${fontFamily.secondary};
  font-size: 14px;
  line-height: 24px;
  font-weight: 700;
  text-transform: uppercase;
`;
const SectionValue = styled.div`
  display: flex;
  align-items: center;
  font-family: ${fontFamily.primary};
  font-size: 14px;
  line-height: ${lineHeight};
  font-weight: 500;
`;
const SidebarSection = styled(withAttrs(Stack, {spacing: "s"}))`
  padding-top: 16px;
  padding-bottom: 16px;
  border-top: 1px solid ${colors.b6};

  &:first-of-type {
    border-top: none;
    padding-top: 0;
  }
`;
const BackLinkSection = styled(SidebarSection)`
  ${media.mobile} {
    display: none;
  }

  ${({editor}) => editor && `
    display: none;
    ${media.mobile} {
      display: block;
    }
  `}
`;
const NextButtonContainer = styled(withAttrs(Button, {stretch: true}))`
  margin-bottom: 12px;
`;
const ProductTitle = styled(withAttrs(Title, {level: 5}))`
  margin-bottom: 16px;
`;
const ConfirmModalFixed = styled(Modal)`
  position: absolute;
  top: 0;
  left: 0;
  right: 410px;
  height: 100vh;

  ${media.mobile} {
    position: fixed;
    right: 0;
  }
`;
